import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useChallengeContext } from '../challenge/useChallengeContext'
import { useChallengeId } from '../challenge/useChallengeId'

export const LEADERBOARD_QUERY_KEY = (challengeID: string, restDaysRequired: number) =>
  ['leaderboard', challengeID, restDaysRequired] as const

export function useLeaderboard() {
  const challengeId = useChallengeId()
  const { data: challengeContext } = useChallengeContext()
  const restDaysRequired = challengeContext?.restDaysRequired

  return useQuery({
    queryKey: LEADERBOARD_QUERY_KEY(challengeId, restDaysRequired ?? 0),
    queryFn: () => {
      if (restDaysRequired === undefined) throw new Error('Challenge is still loading')
      return dataSource.getLeaderboard(challengeId, restDaysRequired)
    },
    enabled: restDaysRequired !== undefined && !!challengeId,
  })
}
